export function convertToUsdString(amount: number, exchangeRate: number): string {
	return (amount / exchangeRate).toFixed(2);
}
